import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import type { SiteWithCounts } from '../../types/project';

interface DeleteSiteDialogProps {
  open: boolean;
  site: SiteWithCounts | null;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteSiteDialog = ({ open, site, onClose, onConfirm }: DeleteSiteDialogProps) => {
  if (!site) return null;

  const hasProjects = site.ProjectCount > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ fontWeight: 700, pb: 0.5 }}>Delete Site</DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2.5 }}>
        {hasProjects ? (
          <Typography variant="body2" color="error">
            Cannot delete &quot;{site.SiteName}&quot; because it has {site.ProjectCount} project(s)
            and {site.LocationCount} location(s). Please reassign or delete those first.
          </Typography>
        ) : (
          <Typography variant="body2">
            Are you sure you want to delete &quot;{site.SiteName}&quot; ({site.SiteCity})?
            This action cannot be undone.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>Cancel</Button>
        {!hasProjects && (
          <Button variant="contained" color="error" onClick={onConfirm}
            sx={{ textTransform: 'none', fontWeight: 600 }}>
            Delete
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
